import React from "react";

const Copy = ({ width, height, fill, ...rest }) => {
  return (
    <svg
      width='25'
      height='29'
      viewBox='0 0 25 29'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g filter='url(#filter0_d_4713_8078)'>
        <path
          d='M8.69531 2.86346V14.1321C8.69531 14.6302 8.89318 15.1079 9.2454 15.4601C9.59761 15.8124 10.0753 16.0102 10.5734 16.0102H18.0859C18.584 16.0102 19.0617 15.8124 19.4139 15.4601C19.7661 15.1079 19.964 14.6302 19.964 14.1321V5.90788C19.9639 5.65767 19.9139 5.41 19.8168 5.1794C19.7198 4.9488 19.5776 4.73992 19.3987 4.56503L16.2857 1.52061C15.9348 1.17754 15.4636 0.985413 14.9729 0.985352H10.5734C10.0753 0.985352 9.59761 1.18322 9.2454 1.53544C8.89318 1.88765 8.69531 2.36536 8.69531 2.86346V2.86346Z'
          stroke='#E31C79'
          strokeWidth='1.50249'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M16.2062 16.0103V17.8884C16.2062 18.3865 16.0083 18.8642 15.6561 19.2164C15.3039 19.5686 14.8262 19.7665 14.328 19.7665H6.81561C6.3175 19.7665 5.8398 19.5686 5.48759 19.2164C5.13537 18.8642 4.9375 18.3865 4.9375 17.8884V7.55877C4.9375 7.06067 5.13537 6.58296 5.48759 6.23075C5.8398 5.87854 6.3175 5.68066 6.81561 5.68066H8.69372'
          stroke='#E31C79'
          strokeWidth='1.50249'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <filter
          id='filter0_d_4713_8078'
          x='0.1875'
          y='0.233887'
          width='24.5273'
          height='28.2837'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'
        >
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='4' />
          <feGaussianBlur stdDeviation='2' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_4713_8078'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_4713_8078'
            result='shape'
          />
        </filter>
      </defs>
    </svg>
  );
};

Copy.defaultProps = {
  width: 68,
  height: 68,
  fill: "white",
};

export default Copy;
